import { api } from './api';

// Novo nome pra supplierService. Endpoints /api/stores do backend.

export const storeService = {
  // Lista pública de lojas ativas — usada no hero do site principal.
  listPublic: async ({ businessType, limit } = {}) => {
    const qs = new URLSearchParams();
    if (businessType) qs.set('businessType', businessType);
    if (limit) qs.set('limit', limit);
    const s = qs.toString();
    return api.get(`/api/stores/public${s ? `?${s}` : ''}`, { includeAuth: false, includeStore: false });
  },

  getBySlug: async (slug) => {
    return api.get(`/api/stores/by-slug/${encodeURIComponent(slug)}`, { includeStore: false });
  },

  getByDomain: async (host) => {
    const qs = new URLSearchParams({ host });
    return api.get(`/api/stores/by-domain?${qs.toString()}`, { includeStore: false });
  },

  getMyStores: async () => {
    return api.get('/api/stores/me', { includeStore: false });
  },

  create: async (payload) => {
    return api.post('/api/stores', payload, { includeStore: false });
  },

  update: async (id, payload) => {
    return api.patch(`/api/stores/${id}`, payload);
  },

  updateTheme: async (id, theme) => {
    return api.patch(`/api/stores/${id}/theme`, { theme });
  },

  updateBusinessType: async (id, payload) => {
    return api.patch(`/api/stores/${id}/business-type`, payload);
  },

  // Resellers
  applyAsReseller: async (storeId) => {
    return api.post(`/api/stores/${storeId}/resellers/apply`, null, { includeStore: false });
  },

  listResellers: async (storeId, { status } = {}) => {
    const qs = status ? `?status=${encodeURIComponent(status)}` : '';
    return api.get(`/api/stores/${storeId}/resellers${qs}`);
  },

  approveReseller: async (storeId, userId) => {
    return api.patch(`/api/stores/${storeId}/resellers/${userId}/approve`, null);
  },

  rejectReseller: async (storeId, userId) => {
    return api.patch(`/api/stores/${storeId}/resellers/${userId}/reject`, null);
  },

  updateResellerAsaasAccount: async (storeId, userId, asaasAccountId) => {
    return api.patch(
      `/api/stores/${storeId}/resellers/${userId}/asaas-account`,
      { asaasAccountId: asaasAccountId || null }
    );
  },

  requestDomainVerification: async (storeId, payload) => {
    return api.post(`/api/stores/${storeId}/domain/request-verification`, payload || {});
  },

  verifyDomain: async (storeId) => {
    return api.post(`/api/stores/${storeId}/domain/verify`, null);
  },

  commissionsSummary: async (storeId) => {
    return api.get(`/api/stores/${storeId}/resellers/me/commissions/summary`, { includeStore: false });
  }
};

export default storeService;
